import { css, styled } from '@mui/material/styles';
import Image from 'next/legacy/image';

import { Theme, containerLargeWidth, rem } from '../../theme';
import { Heading } from '../Heading';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        padding-top: ${theme.tggSpacing(rem(5), 20)};
        padding-bottom: ${theme.tggSpacing(rem(3), 12)};
        margin-bottom: ${theme.tggSpacing(rem(0.8), 3)};
        text-align: center;
        background-color: ${theme.palette.common.white};

        ${theme.breakpoints.up('desktop')} {
            padding-top: ${theme.tggSpacing(rem(10), 40)};
            padding-bottom: ${theme.tggSpacing(rem(8), 32)};
        }
	`}
`;

export const StyledImageContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        position: relative;
        width: 100%;
        height: ${theme.tggSpacing(rem(23.6), 94.5)};
        margin: ${theme.tggSpacing([rem(1), 0, rem(2), 0], [4, 0, 8, 0])};

        ${theme.breakpoints.up('desktop')} {
            height: ${theme.tggSpacing(rem(38.2), 153)};
        }
	`}
`;

export const StyledImage: any = styled(Image)`
    object-fit: contain;
`;

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            max-width: ${theme.tggSpacing(rem(containerLargeWidth))};
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        }
	`}
`;

const contentStyles = (theme: Theme) => css`
    padding-right: ${theme.tggSpacing(rem(3), 12)};
    padding-left: ${theme.tggSpacing(rem(3), 12)};
`;

export const StyledContent = styled('div')`
    ${({ theme }: { theme: Theme }) => contentStyles(theme)}
`;

export const StyledMainHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => contentStyles(theme)}
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_25_bold_desktop_31};
    ${({ theme }: { theme: Theme }) => `
        margin-right: ${theme.tggSpacing(0, 0)};
        margin-left: ${theme.tggSpacing(0, 0)};
	`}
`;

export const StyledButtonsContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        gap: ${theme.tggSpacing(rem(2), 8)};

        ${theme.breakpoints.up('mobile')} {
            display: inline-flex;
        }
	`}
`;
